export const MAX_COLS = 24;
export const MAX_ROWS = 3;
